<ui-grid [data]="data$ | async"
         [loading]="loading$ | async">
    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>

        <ui-header-button type="main">
            <ng-template>
                <button [uiAuthorize]="'Roles.Create'"
                        [matTooltip]="'grid_action_add' | translate"
                        [uiClickTrack]="'Action: Add Role'"
                        (click)="openModal()"
                        mat-mini-fab
                        color="primary"
                        data-cy="role-add"
                        type="button">
                    <mat-icon>add</mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="action">
            <ng-template>
                <button [uiAuthorize]="'Roles.Delete'"
                        [disabled]="!allowDelete"
                        [matTooltip]="'roles_page_grid_action_remove' | translate"
                        (click)="removeItems()"
                        mat-icon-button
                        color="warn"
                        data-cy="role-delete-global"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete20px">
                    </mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>

    <ui-grid-column [sortable]="true"
                    [searchable]="true"
                    [title]="'roles_page_grid_name' | translate"
                    property="displayName"
                    sort="asc"
                    width="100%">
    </ui-grid-column>

    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button [matTooltip]="'global_more_actions_tooltip' | translate"
                    [matMenuTriggerFor]="menu"
                    data-cy="grid-action-menu"
                    mat-icon-button
                    type="button">
                <mat-icon svgIcon="uipath:More"></mat-icon>
            </button>
            <mat-menu #menu="matMenu">

                <button [uiAuthorize]="'Roles.Edit'"
                        [uiClickTrack]="'Action: Grid: Edit'"
                        (click)="openModal(entry)"
                        mat-menu-item
                        data-cy="role-action-edit"
                        type="button">
                    <mat-icon svgIcon="uipath:Edit">
                    </mat-icon>
                    {{ 'roles_page_grid_action_edit' | translate }}
                </button>

                <button [uiAuthorizeAllDisable]="['Roles.View','Users.View']"
                        [uiClickTrack]="'Action: Grid: Manage Users'"
                        (click)="openUsersModal(entry)"
                        mat-menu-item
                        data-cy="role-action-manage-users"
                        type="button">
                    <mat-icon>supervisor_account</mat-icon>
                    {{ 'roles_page_grid_action_manage' | translate }}
                </button>

                <button [uiAuthorize]="'Roles.Delete'"
                        [disabled]="entry.isStatic"
                        [uiClickTrack]="'Action: Grid: Remove'"
                        (click)="removeItems([entry])"
                        mat-menu-item
                        color="warn"
                        role="role-remove"
                        data-cy="role-action-delete"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete">
                    </mat-icon>
                    {{ 'roles_page_grid_action_remove' | translate }}
                </button>

            </mat-menu>
        </ng-template>
    </ui-grid-row-action>

    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
